import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ResetPasswordService} from "../../lib/services/reset-password/reset-password.service";
import jwt_decode from "jwt-decode";
import * as pubsub from "pubsub-js"
import {GenericModalService} from "../../lib/services/generic-modal/generic-modal.service";

@Component({
    selector: 'lib-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {


    cveUsuario: string = "";
    isValidToken: boolean = false;
    sNameUser: string;
    dJWT_Pass: string = "";
    urlTree: any;
    token: any;
    chargedForm: boolean = true;
    email: string = "";
    showFormOrError = false;
    loading = false

    constructor(
        private router: Router,
        private resetPassword: ResetPasswordService,
        private genericModal: GenericModalService,
    ) {
        this.urlTree = this.router.parseUrl(this.router.url);
        this.token = this.urlTree.queryParams['uuid'];
        pubsub.subscribe("modalClosed", this.onModalClosed.bind(this));
    }

    validateToken(sToken: string) {
        this.resetPassword.validateToken(this.token).subscribe({
            next: value => {
                if (value.nameUser != null) {
                    this.chargedForm = true;
                    this.isValidToken = true;
                    sessionStorage.setItem("ACCESS_TOKEN_WSO_PASS", value.message);
                    this.dJWT_Pass = JSON.stringify(jwt_decode(value.message));
                    const tokenDecode: any = this.dJWT_Pass ? JSON.parse(this.dJWT_Pass) : {}
                    this.cveUsuario = tokenDecode.usuario;
                    this.sNameUser = value.nameUser;
                    this.email = tokenDecode.email;
                    this.showFormOrError = true;

                } else {
                    this.chargedForm = true;
                    this.isValidToken = false;
                }
            },
            complete: () => {
                this.showFormOrError = true;
            }
        })
    }

    ngOnInit(): void {
        this.validateToken(this.token);
    }

    ngOnDestroy() {
        // Asegúrate de cancelar la suscripción cuando el componente se destruya
        pubsub.unsubscribe('modalClosed');
    }


    savePassword(event): void {
        this.loading = true
        const {password} = event;
        const jwt: string | null = sessionStorage.getItem("ACCESS_TOKEN_WSO_PASS");
        this.resetPassword.savePassword(password, jwt).subscribe({
            next: value => {
                if (value.message == "Contraseña modificada con exito") {
                    sessionStorage.clear();
                    this.genericModal.open("¡Listo!", "Cambiaste tu contraseña", "SUCCESS");
                } else {
                    this.genericModal.open("Error", "Error al almacenar nueva contraseña", "ERROR");
                }
            },
            error: err => {
                console.error(err);
                this.genericModal.open("Error", "Error al almacenar nueva contraseña", "ERROR");
            },
            complete: () => {
                this.loading = false;
            }
        })

    }


    close() {
        this.resetPassword.close();
    }

    onModalClosed() {
        this.resetPassword.close();
        this.router.navigate(['/login']);
    }


}
